var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("popup-view", {
    staticClass: "l-popup u-expand",
    nativeOn: {
      click: function($event) {
        return _vm.close($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }